import { render } from "./loginPhone.vue?vue&type=template&id=f5d05696&scoped=true"
import script from "./loginPhone.vue?vue&type=script&lang=js"
export * from "./loginPhone.vue?vue&type=script&lang=js"

import "./loginPhone.vue?vue&type=style&index=0&id=f5d05696&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d05696"]])

export default __exports__